import styled from "styled-components";
import { useMutation, useQuery } from "@tanstack/react-query";
import { LoadingBackDrop } from "../../../components/loader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { theme } from "../../../helpers/theme";
import { getAllWarehouses } from "../../../services/warehouses/get-all";
import { useEffect, useState } from "react";
import { WarehousesGallery } from "../../../services/warehouses/get-all/types";
import { AddImage } from "./components/add-image";
import { ImageGallery } from "./components/image-gallery";
import { GalleryNavigation } from "./components/gallery-navigation";

export const WarehousesGalleryView = () => {
  const { id } = useParams();
  const [isGalleryLoading, setIsGalleryLoading] = useState(false);
  const [imagesList, setImagesList] = useState<WarehousesGallery[]>([]);
  const [isGalleryChange, setIsGalleryChange] = useState(false);

  const body = {
    paginacja: null,
    filtr: {
      id_magazyn: id ? id : null,
    },
  };

  const { isLoading } = useQuery(["warehouses"], () => getAllWarehouses(body), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onSuccess(data) {
      setImagesList(data.data.payload.magazyny[0].zdjecia_magazynu);
    },
  });

  if (isLoading) {
    return <LoadingBackDrop loading={true} />;
  }

  return id ? (
    <GalleryPageWrapper>
      <GalleryNavigation />
      <ImageGallery
        imagesList={imagesList}
        magazyn_id={id}
        isGalleryLoading={isGalleryLoading}
        setImagesList={setImagesList}
        setIsGalleryLoading={setIsGalleryLoading}
      />
      <AddImage
        MagazynId={id}
        isGalleryChange={isGalleryChange}
        setIsGalleryChange={setIsGalleryChange}
        setImagesList={setImagesList}
        setIsGalleryLoading={setIsGalleryLoading}
      />
    </GalleryPageWrapper>
  ) : (
    null
  );
};

const GalleryPageWrapper = styled.div`
  height: 80vh;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding-right: 0;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
